module.exports = "/images/inheritance-background.png?0cc80948b2aec8352395153abc2afb8c";